module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-block"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.path
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed23b6d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockImage.vue
// module id = 724
// module chunks = 0